import React from "react";
import { Container } from "../../../../components";
import { connect } from "react-redux";
import Pages from "../../../../../../constants/pages";
import { RootState } from "../../../../../../models";
import { getHasSentTransferOrder } from "../../../../checkout/state/selectors/accountSelectors";
import TEXT from "../../../text-consts";
import BackLink from "../../atoms/BackLink/BackLink";
import ConfirmIdBackButton from "../ConfirmIdBackButton/ConfirmIdBackButton";
import ConfirmIdContinueButton from "../ConfirmIdContinueButton/ConfirmIdContinueButton";
import ConfirmNumberContinueButton from "../ConfirmNumberContinueButton/ConfirmNumberContinueButton";
import RequestTransferOfOwnershipContinueButton from "../RequestTransferOfOwnershipContinueButton/RequestTransferOfOwnershipContinueButton";
import SummaryContinueButton from "../SummaryContinueButton/SummaryContinueButton";

interface WrappedContinueButtonProps {
    path: string;
}

const WrappedContinueButton: React.FC<WrappedContinueButtonProps> = ({ path }) => {
    switch (path) {
        case Pages.TRANSFER_OWNERSHIP.CONFIRM_ID.URL:
            return <ConfirmIdContinueButton />;
        case Pages.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.URL:
            return <ConfirmNumberContinueButton url={Pages.TRANSFER_OWNERSHIP.SUMMARY.URL} />;
        case Pages.TRANSFER_OWNERSHIP.SUMMARY.URL:
            return <SummaryContinueButton url={Pages.TRANSFER_OWNERSHIP.REQUEST_TRANSFER_OF_OWNERSHIP.URL} />;
        case Pages.TRANSFER_OWNERSHIP.REQUEST_TRANSFER_OF_OWNERSHIP.URL:
            return <RequestTransferOfOwnershipContinueButton />;
        default:
            return null;
    }
};

interface BackButtonProps {
    hasSentTransferOrder: boolean;
    path: string;
}

const BackButton: React.FC<BackButtonProps> = ({ path = "", hasSentTransferOrder }) => {
    let href = "";

    switch (path) {
        case Pages.TRANSFER_OWNERSHIP.CONFIRM_ID.URL:
            return <ConfirmIdBackButton />;
            break;
        case Pages.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.URL:
            href = Pages.TRANSFER_OWNERSHIP.CONFIRM_ID.URL;
            break;
        case Pages.TRANSFER_OWNERSHIP.SUMMARY.URL:
            href = Pages.TRANSFER_OWNERSHIP.CONFIRM_NUMBER.URL;
            break;
        case Pages.TRANSFER_OWNERSHIP.REQUEST_TRANSFER_OF_OWNERSHIP.URL:
            href = hasSentTransferOrder ? "/" : Pages.TRANSFER_OWNERSHIP.SUMMARY.URL;
            break;
        default:
            return null;
    }

    return (
        <BackLink
            href={href}
            text={hasSentTransferOrder ? TEXT.REQUEST_TRANSFER_OF_OWNERSHIP.BACK_BUTTON_TEXT : TEXT.COMMON.BACK}
        />
    );
};

interface ContinueSectionProps {
    hasSentTransferOrder?: boolean;
    isReadyToContinue: boolean;
    path: string;
}

const ContinueSection: React.FC<ContinueSectionProps> = ({ isReadyToContinue, path, hasSentTransferOrder = false }) => (
    <Container className="transfer-ownership-page--space-between" size="medium" noMargin>
        <BackButton path={path} hasSentTransferOrder={hasSentTransferOrder} />
        {isReadyToContinue && (
            <div
                className="transfer-ownership-page__continue-button-container"
                data-cy="transfer-ownership-continue-button"
            >
                <WrappedContinueButton path={path} />
            </div>
        )}
    </Container>
);

const mapStateToProps = (state: RootState) => ({
    hasSentTransferOrder: getHasSentTransferOrder(state),
});

export default connect(mapStateToProps)(ContinueSection);
